import React from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationAlert } from "../../../../../cargotic-webapp-component";

const RoleDeleteConfirmationAlert = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationAlert
      title={t("webapp:settings.title.delete-user-role")}
      content={t("webapp:settings.prompt.delete-role")}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default RoleDeleteConfirmationAlert;
